import React, { FC } from "react";
import { FormGroup as MuiFormGroup, FormGroupProps } from "@mui/material";

const FormGroup: FC<FormGroupProps> = (props) => <MuiFormGroup {...props} />;

export default FormGroup;
